module.exports = __webpack_public_path__ + "img/img_mao.6923908c.png";